import { memo, useCallback, useState } from "react";

import type { ImportFileResponse, ValidateFileResponse } from "../Company/queries/apiTypes";
import BulkImport from "./BulkImport";
import ResolutionModal from "./ResolutionModal";

const MODAL_TYPE = {
    CONFLICT_AND_SUMMARY: 'CONFLICT_AND_SUMMARY',
    UPLOAD_FILE: 'UPLOAD_FILE',
} as const;

type ModalState =
    | { type: typeof MODAL_TYPE.CONFLICT_AND_SUMMARY, data: ValidateFileResponse }
    | { type: typeof MODAL_TYPE.UPLOAD_FILE };

interface ImportContactFlowProps {
    closeDialog: () => void;
    onUploadSuccess: (response: ImportFileResponse) => void;
}

const ImportContactFlow = memo(function ImportContactFlow(props: ImportContactFlowProps) {
    const { closeDialog, onUploadSuccess } = props;
    const [currentModalState, setCurrentModalState] = useState<ModalState>({ type: MODAL_TYPE.UPLOAD_FILE });

    const handleNextStepAfterImport = useCallback((data: ValidateFileResponse) => {
        setCurrentModalState({ type: MODAL_TYPE.CONFLICT_AND_SUMMARY, data })
    }, []);

    switch (currentModalState.type) {
        case MODAL_TYPE.UPLOAD_FILE:
            return <BulkImport open onClose={closeDialog} handleNextStep={handleNextStepAfterImport} />;
        case MODAL_TYPE.CONFLICT_AND_SUMMARY:
            return (
                <ResolutionModal
                    onClose={closeDialog}
                    onUploadSuccess={onUploadSuccess}
                    initialData={currentModalState.data}
                />
            )
        default:
            return null;
    }
});

export default ImportContactFlow;